











































































































































































































































































































































































































import { EnumPermission } from '@/domain/permission'
import { Inventaire_StatutModifie, ProduitLightOutput, TraitementInventaireProduitStatut_ToText } from '@/domain/ProduitLightOutput'
import { RoleEnum } from '@/domain/role'
import _ from 'lodash'
import mixins from 'vue-typed-mixins'
import InventaireMixin from './InventaireMixin'
import { InventaireEffectueOutput } from './models/InventaireEffectueOutput'
import { InventaireStatut, TraitementInventaireStatut_ToText } from './models/InventaireStatut'
import moment from 'moment'

export default mixins(InventaireMixin).extend({
    data: function () {
        return {
            panel: [],
            statutsProduits: [
                { text: 'En trop', value: 0 },
                { text: 'Manquant', value: 1 },
                { text: 'Conforme', value: 2 },
            ],
            searchCodeClient: '',
            searchInventoriste: '',
            searchStatut: '',
            searchADV: '',
            searchDateCreation: '',
        }
    },
    methods: {
        getCodeClientName(codeClient: string) {
            return _.find(this.companiesAutoComplete, (c) => codeClient == c.value)?.text || ''
        },
        formatStatutInventaire(inventaire: InventaireEffectueOutput) {
            return TraitementInventaireStatut_ToText(inventaire.statut)
        },
        formatStatutInventaireProduit(statut: Inventaire_StatutModifie) {
            return TraitementInventaireProduitStatut_ToText(statut)
        },
        colorStatutInventaire(inventaire: InventaireEffectueOutput) {
            return inventaire.statut == InventaireStatut.Nouveau ? 'info' : inventaire.statut == InventaireStatut.Traite ? 'success' : 'warning'
        },
        filterInventaireCodeClient(search: string, item: string) {
            return this.getCodeClientName(item).toLowerCase().indexOf(search) !== -1
        },
        filterInventaireStringClassique(search: string, item: string): boolean {
            return item != null && item != '' && item != undefined && item.indexOf(search) !== -1
        },
        filterInventaire(value: any, search: string | null, item: InventaireEffectueOutput) {
            if (search === null) return true

            return
        },
        ajouterProduitInventaire() {
            if (!this.inventaire) return

            this.inventaireProduitTemp = new ProduitLightOutput()
            this.inventaireProduitTemp.inventaireEffectueId = this.inventaire.id
            this.inventaireProduitTemp.id = -1
            this.openableInventaireProduit.open()
        },
        modificationStatutInventaire(id: number, statut: InventaireStatut) {
            this.$http
                .api('inventaire/statut')
                .post({
                    id: id,
                    statut: statut,
                })
                .then((x) => {
                    this.getResultatInventaires()
                    this.loadPastilles()
                    this.$swal.toast.success("L'inventaire a bien été mis à jour.")
                })
                .catch((x) => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
    },
    computed: {
        allStatutsDemandes() {
            return Object.keys(InventaireStatut)
                .filter((key: any) => !isNaN(Number(key)))
                .map((x) => ({ val: +x, text: TraitementInventaireStatut_ToText(+x) }))
        },
        allStatutsDemandesPourFiltre() {
            return [
                { value: '', text: '' },
                ...Object.keys(InventaireStatut)
                    .filter((key: any) => !isNaN(Number(key)))
                    .map((x) => ({ value: TraitementInventaireStatut_ToText(+x), text: TraitementInventaireStatut_ToText(+x) })),
            ]
        },
        allStatutsProduit() {
            return Object.keys(Inventaire_StatutModifie)
                .filter((key: any) => !isNaN(Number(key)) /*&& key != Inventaire_StatutModifie.Ok*/)
                .map((x) => ({ value: +x, text: TraitementInventaireProduitStatut_ToText(+x) }))
        },
        canDelete() {
            return this.$database.account.permissions.indexOf(EnumPermission.Inventaire_Delete) !== -1
        },
        isNotCommercial() {
            return this.$database.account.roleEnum != RoleEnum.Commercial
        },
        produitsManquants() {
            if (!this.inventaire) {
                return []
            } else {
                return _.filter(this.inventaire.produitsModifies, (x) => (x.nouveauStatut != null && x.nouveauStatut == Inventaire_StatutModifie.Manquant) || (x.nouveauStatut == null && x.ancienStatut == Inventaire_StatutModifie.Manquant))
            }
        },
        produitsEnTrop() {
            if (!this.inventaire) {
                return []
            } else {
                return _.filter(this.inventaire.produitsModifies, (x) => (x.nouveauStatut != null && x.nouveauStatut == Inventaire_StatutModifie.EnTrop) || (x.nouveauStatut == null && x.ancienStatut == Inventaire_StatutModifie.EnTrop))
            }
        },
        produitsConforme() {
            if (!this.inventaire) {
                return []
            } else {
                return _.filter(this.inventaire.produitsModifies, (x) => (x.nouveauStatut != null && x.nouveauStatut == Inventaire_StatutModifie.Ok) || (x.nouveauStatut == null && x.ancienStatut == Inventaire_StatutModifie.Ok))
            }
        },
        produitsRegularises() {
            if (!this.inventaire) {
                return []
            } else {
                return _.filter(this.inventaire.produitsModifies, (x) => (x.nouveauStatut != null && x.nouveauStatut == Inventaire_StatutModifie.Regularise) || (x.nouveauStatut == null && x.ancienStatut == Inventaire_StatutModifie.Regularise))
            }
        },
        headers() {
            return [
                {
                    text: 'Code client',
                    value: 'codeClient',
                    filter: (value: string, search: string): boolean => {
                        if (!this.searchCodeClient) return true

                        return this.filterInventaireCodeClient(this.searchCodeClient.toLowerCase(), value.toString())
                    },
                },
                {
                    text: 'Inventoriste',
                    value: 'nomUtilisateurCreateur',
                    filter: (value: string): boolean => {
                        if (!this.searchInventoriste) return true
                        if (!value) return false

                        return this.filterInventaireStringClassique(this.searchInventoriste.toLowerCase(), value.toLowerCase())
                    },
                },
                { text: 'Etat', value: 'etat' },
                {
                    text: 'Statut',
                    value: 'statut',
                    filter: (value: number): boolean => {
                        if (!this.searchStatut && this.searchStatut != '0') return true
                        console.log(value)
                        if (!value && value != 0) return false

                        return this.searchStatut == TraitementInventaireStatut_ToText(value)
                    },
                },
                {
                    text: 'ADV en charge',
                    value: 'lastUserTraitement',
                    filter: (value: string | null): boolean => {
                        if (!this.searchADV) return true
                        if (!value) return false
                        return this.filterInventaireStringClassique(this.searchADV.toLowerCase(), value.toLowerCase())
                    },
                },
                {
                    text: 'Date de création',
                    value: 'dateCreation',
                    filter: (value: string): boolean => {
                        if (!this.searchDateCreation) return true
                        if (!value) return false

                        return this.filterInventaireStringClassique(this.searchDateCreation.toLowerCase(), value.toLowerCase())
                    },
                    sort: (dateA: string, dateB: string) => {
                        const dateAParsed = moment(dateA, 'DD/MM/YYYY HH:mm')
                        const dateBParse = moment(dateB, 'DD/MM/YYYY HH:mm')
                        return dateAParsed < dateBParse ? 1 : dateAParsed > dateBParse ? -1 : 0
                    },
                },
                { text: '', value: 'action' },
            ]
        },
    },
})
